export const NOINDEX_FOLLOW = 'noindex,follow' as const

/** Paths disallowed for all crawlers in robots.txt. */
export const ROBOTS_DISALLOW_PATHS = [
  '/api/',
  '/editor/',
  '/admin/',
  '/pricing',
  '/merchant/',
  '/login',
  '/signup',
  '/account',
  '/forgot-password',
  '/reset-password',
] as const

/** Route prefixes that must never appear in sitemap.xml. */
export const NON_SITEMAP_PATH_PREFIXES = [
  '/login',
  '/signup',
  '/forgot-password',
  '/reset-password',
  '/account',
  '/admin',
  '/pricing',
  '/merchant',
  '/submit',
  '/recommend',
] as const

export function noindexHeadMeta() {
  return [
    { name: 'robots', content: NOINDEX_FOLLOW },
    { name: 'googlebot', content: NOINDEX_FOLLOW },
  ] as const
}

export function noindexRouteHead(title: string) {
  return {
    meta: [{ title }, ...noindexHeadMeta()],
  }
}

export function buildRobotsTxt(site: string): string {
  const disallow = ROBOTS_DISALLOW_PATHS.map(
    (path) => `Disallow: ${path}`,
  ).join('\n')

  return `# https://www.robotstxt.org/robotstxt.html
User-agent: *
Content-Signal: ai-train=no, search=yes, ai-input=yes
${disallow}

# AI search/indexing crawlers — allowed (permits crawl for search features; no inclusion guarantee)
# Training preference is also expressed via Content-Signal (ai-train=no) above.
User-agent: GPTBot
Allow: /

User-agent: OAI-SearchBot
Allow: /

User-agent: ClaudeBot
Allow: /

User-agent: PerplexityBot
Allow: /

# Google-Extended: allowed for Google's AI-assisted search surfaces
User-agent: Google-Extended
Allow: /

# AI training crawlers — disallowed (protect editorial content)
User-agent: CCBot
Disallow: /

User-agent: Diffbot
Disallow: /

Sitemap: ${site}/sitemap.xml
`
}
